import { CompetitorComparisonLayout } from "@/components/marketing/CompetitorComparisonLayout";
import { COMPETITORS } from "@/lib/marketing-competitor-matrix";

export default function VsChatGPTPage() {
  return <CompetitorComparisonLayout competitor={COMPETITORS["chatgpt-seul"]} />;
}
